import axios from './index'
var qs = require('qs');
import { cleanParams } from '@/filters'
// import store from '@/store'
// 分页获取
export const getDataByPage = (params) => {
  // const currentRole = store.state.currentRole
  // const { companyId, teamId } = currentRole
  return axios.get('/welldbCombine/item/page', {
    params: cleanParams({ ...params })
  })
}

export const updateDataItem = (params) => {
  return axios.put('/welldbCombine/item', {
    moveToQuery: true,
    params: cleanParams(params)
  })
}

// 获取一项数据的box标注
export const getItemBoxLabel = (id, pageSize) => {
  return axios.get('/welldbCombine/itemAndXy', {
    params: {
      itemId: id,
      pageNum: 1,
      pageSize: pageSize

    }
  })
}
export const addItemBoxLabel = (params) => {
  return axios.post('/welldbCombine/itemAndXy', {
    moveToQuery: true,
    params
  })
}

export const updateItemBoxLabel = (params) => {
  return axios.put('/welldbCombine/itemAndXy',qs.stringify({
    id:params.id,
    polygon:params.polygon,
    objectDetection:params.objectDetection
  }))
}

export const deleteItemBoxLabel = (id) => {
  return axios.delete('/welldbCombine/itemAndXy', {
    params: {
      id
    }
  })
}

// 获取一项数据的tag标注
export const getItemTagLabel = (id) => {
  return axios.get('/welldbCombine/itemAndTag', {
    params: {
      itemId: id,
      pageNum: 1,
      pageSize: 10000
    }
  })
}

export const addItemTagLabel = (params) => {
  return axios.post('/welldbCombine/itemAndTag', {
    moveToQuery: true,
    params
  })
}

export const deleteItemTagLabel = (id) => {
  return axios.delete('/welldbCombine/itemAndTag', {
    params: {
      id
    }
  })
}
